// ** Kameralar
const initialIIBServiceState = {}

const IIBService = (state = initialIIBServiceState, action) => {
  switch (action.type) {
    case "SET_IIB_TYPES_CONTENT":
      return { ...state, ...action.val }
    default:
      return state
  }
}

export default IIBService
